<div class="text-red-500 flex items-center space-x-2">
  <fa-icon
    [icon]="faCircleXmark"
    class="text-xl tablet-min:text-2xl text-red-500"
  ></fa-icon>
  <span class="text-sm tablet-min:text-base">
    {{ data.message }}
  </span>
</div>
